/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type KoguiReservasQueryType = 'all' | 'active' | 'past' | 'unrating';

export const KoguiReservasQueryType = {
    All: 'all' as KoguiReservasQueryType,
    Active: 'active' as KoguiReservasQueryType,
    Past: 'past' as KoguiReservasQueryType,
    Unrating: 'unrating' as KoguiReservasQueryType
};

